import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import initializeProductVariationSelection from './product-variation-selection';

initializeProductVariationSelection();

/* product gallery carousel */
domReady(() => {
  const galleryCarousel = document.querySelector('.product-gallery__carousel');

  if (galleryCarousel) {
    new Swiper(galleryCarousel, {
      slidesPerView: 1,
      loop: true,
      watchOverflow: true,
      spaceBetween: 12,
      navigation: {
        prevEl: galleryCarousel.querySelector('.swiper-button-prev'),
        nextEl: galleryCarousel.querySelector('.swiper-button-next'),
      },
    });
  }
});

/* update book identifiers and resources with the selected variation */
domReady(() => {
  jQuery(function ($) {
    const $variationDetails = $('[data-book-variation-details]');
    const $resources = $('[data-book-resources]');

    const updateResource = (name, value) => {
      if (!$resources.length) {
        return;
      }

      const safeValue = /^https?:\/\//i.test(String(value || ''))
        ? String(value)
        : '';
      $resources.find(`[data-book-resource="${name}"]`).attr('href', safeValue);
      $resources
        .find(`[data-book-resource-row="${name}"]`)
        .prop('hidden', !safeValue);
    };

    const resourceOrParent = (name, value) => {
      const candidate = String(value || '');
      return /^https?:\/\//i.test(candidate)
        ? candidate
        : $resources.attr(`data-parent-${name}-url`);
    };

    const updateVariationDetail = (name, value) => {
      if (!$variationDetails.length) {
        return;
      }

      const safeValue = String(value || '');
      $variationDetails
        .find(`[data-book-variation-detail="${name}"]`)
        .text(safeValue);
      $variationDetails
        .find(`[data-book-variation-row="${name}"]`)
        .prop('hidden', !safeValue);
    };

    const updateVariationDetails = (variation = {}) => {
      $variationDetails.find('[data-book-variation-row]').each(function () {
        const $row = $(this);
        const name = $row.attr('data-book-variation-row');
        const property = $row.attr('data-book-variation-property');

        updateVariationDetail(name, variation[property]);
      });
    };

    const resetBookData = () => {
      updateVariationDetails();
      updateResource('sample', $resources.attr('data-parent-sample-url'));
      updateResource('flipbook', $resources.attr('data-parent-flipbook-url'));
    };

    $('.variations_form')
      .on('found_variation', function (event, variation) {
        updateVariationDetails(variation);
        updateResource(
          'sample',
          resourceOrParent('sample', variation.book_sample_url)
        );
        updateResource(
          'flipbook',
          resourceOrParent('flipbook', variation.book_flipbook_url)
        );
      })
      .on('reset_data hide_variation', resetBookData);

    resetBookData();
  });
});

/* related products and recommendations carousels */
domReady(() => {
  const initializeRelatedCarousels = () => {
    document.querySelectorAll('.related-products').forEach((relatedSection) => {
      const relatedCarousel = relatedSection.querySelector(
        '.related-products__carousel'
      );

      if (!relatedCarousel || relatedCarousel.swiper) {
        return;
      }

      new Swiper(relatedCarousel, {
        slidesPerView: 1,
        loop: false,
        watchOverflow: true,
        navigation: {
          prevEl: relatedSection.querySelector('.swiper-button-prev'),
          nextEl: relatedSection.querySelector('.swiper-button-next'),
        },

        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
        },
      });
    });
  };

  initializeRelatedCarousels();
  // The recommendations plugin replaces its placeholders through AJAX.
  jQuery(window).on(
    'wc_prl_deployments_after_render',
    initializeRelatedCarousels
  );
});

/* add variation description tab */
domReady(() => {
  jQuery(function ($) {
    const $accordion = $('.variation-description-accordion');
    const $content = $('.variation-description-content');

    $('.variations_form')
      .on('found_variation', function (event, variation) {
        if (variation.variation_description) {
          $content.html(variation.variation_description);

          $accordion.show();
        } else {
          $content.empty();
          $accordion.hide();
        }
      })

      .on('reset_data', function () {
        $content.empty();
        $accordion.hide();
      });
  });
});

/* move whishlist button */
domReady(() => {
  const wishlistButtonWrapper = document.querySelector(
    '.summary > .single_product_div'
  );
  const productTitleWrapper = document.querySelector('.product__title-wrapper');

  if (wishlistButtonWrapper && productTitleWrapper) {
    productTitleWrapper.append(wishlistButtonWrapper);
  }
});
